
















import { Prop, Component, Vue } from 'vue-property-decorator';
import Album from '@/types/Album';

@Component
export default class AlbumReeditions extends Vue {
  @Prop() private albumId!: String;
  @Prop() private reeditedAlbums!: Array<Album>;

  public textOnButton(): String {
    const { length } = this.reeditedAlbums;

    if (length > 1) {
      return `Voir les ${length} rééditions`;
    } else return `Voir la réédition `;
  }

  public coverPath(album: Album) {
    try {
      return require(`@/assets/albums/${this.albumId}/${album.cover}`);
    } catch (e) {
      console.log(`No cover found for ${this.albumId}/${album.cover}`);

      return `https://fakeimg.pl/320x450/?text=${this.albumId}`;
    }
  }
}
